import { DataTransformationGoogleAnalyticsMapperInterface } from './data-transformation-mapper.interface';

export class DataTransformationGoogleAnalyticsMapper implements DataTransformationGoogleAnalyticsMapperInterface {
  map(
    entityType:
      | 'EVENT'
      | 'EXHIBITOR'
      | 'POST'
      | 'PRODUCT'
      | 'CONTACT_PERSON'
      | 'CONTRIBUTOR'
      | 'SEARCH_RESULT'
      | 'EXHIBITOR_SEARCH_RESULT'
      | 'BRAND_SEARCH_RESULT'
      | 'WATCHLIST',
    entity: any
  ) {
    switch (entityType) {
      case 'EVENT':
        return {
          ...(entity.id && { event_id: entity.id }),
          event_name: entity.name ?? entity.headline,
        };
      case 'EXHIBITOR':
        return {
          exhibitor_id: entity.id,
          exhibitor_name: entity.display_name ?? entity.name,
        };
      case 'EXHIBITOR_SEARCH_RESULT':
        return {
          exhibitor_id: entity.exhibitor.id,
          exhibitor_name: entity.exhibitor.name,
        };
      case 'BRAND_SEARCH_RESULT':
        return {
          exhibitor_id: entity.brand.exhibitor?.id,
          exhibitor_name: entity.brand.exhibitor?.name,
        };
      case 'POST':
        return {
          post_id: entity.id,
          post_name: entity.name ?? entity.headline,
        };
      case 'PRODUCT':
        return {
          product_id: entity.id,
          product_name: entity.name,
        };
      case 'CONTRIBUTOR':
      case 'CONTACT_PERSON':
        return {
          contact_person_id: entity.id,
        };
      case 'SEARCH_RESULT':
        return {
          item_id: entity.id,
          ...(entity.name && { item_name: entity.name }),
          ...(entity.exhibitor_id && { exhibitor_id: entity.exhibitor_id }),
          ...(entity.exhibitor_name && { exhibitor_name: entity.exhibitor_name }),
        };
      case 'WATCHLIST':
        return {
          ...(entity.exhibitor && { exhibitor_id: entity.exhibitor.id, exhibitor_name: entity.exhibitor.name }),
          ...(entity.brand && { exhibitor_id: entity.brand.id, exhibitor_name: entity.brand.name }),
          ...(entity.product && { product_id: entity.product.id, product_name: entity.product.name }),
          ...(entity.event && { event_id: entity.event.id, event_name: entity.event.headline }),
          ...(entity.post && { post_id: entity.post.id, post_name: entity.post.headline }),
          ...(entity.contactPerson && { contact_person_id: entity.contactPerson.id }),
        };
      default:
        throw new Error('Method not implemented.');
    }
  }

  filter(type: string, text?: string) {
    if (
      type === 'TELEPHONE_CONTACT_PERSON' ||
      type === 'MAIL_CONTACT_PERSON' ||
      type === 'TELEPHONE_COMPANY' ||
      type === 'MAIL_COMPANY'
    ) {
      return undefined;
    }

    return text;
  }
}
